import(/* webpackMode: "eager" */ "/app/next/app/[root]/(bare)/error.tsx");
